import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/backoffice/campaigns")({
  component: () => <Outlet />,
})
